import { Navigate } from 'react-router-dom';
import { useUser } from './AuthProvider';

/**
 * Gate for authenticated routes. Two-stage wait so consumers can rely
 * on `profile` being non-null:
 *
 *   1. `loading` is true until `onIdTokenChanged` fires the first time.
 *   2. After sign-in `profile` is fetched via the `users/{uid}` snapshot;
 *      we wait for that too so downstream components (membership banner,
 *      sidebar, settings hooks) never see `profile === null` for an
 *      authenticated user.
 *
 * This also closes the auth-state race that previously rendered
 * protected pages with stale defaults during the snapshot round-trip.
 */
export function AuthGuard({ children }: { children: React.ReactNode }) {
  const { user, profile, loading } = useUser();
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground">
        Lade …
      </div>
    );
  }
  if (!user) return <Navigate to="/signin" replace />;
  if (!profile) {
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground">
        Lade Profil …
      </div>
    );
  }
  return <>{children}</>;
}
